import React, { useRef } from 'react';
import { motion, useMotionValue, useMotionTemplate } from 'framer-motion';

/* Card with a soft glow that follows the cursor (for dark sections) */
export default function Spotlight({ children, className = '', color = 'rgba(37,99,235,.35)', ...rest }) {
  const ref = useRef(null);
  const mx = useMotionValue(-300);
  const my = useMotionValue(-300);
  const bg = useMotionTemplate`radial-gradient(380px circle at ${mx}px ${my}px, ${color}, transparent 70%)`;
  return (
    <motion.div ref={ref} className={`spot ${className}`} {...rest}
      onPointerMove={(e) => { const r = ref.current.getBoundingClientRect(); mx.set(e.clientX - r.left); my.set(e.clientY - r.top); }}
      onPointerLeave={() => { mx.set(-300); my.set(-300); }}>
      <motion.span className="spot-glow" style={{ background: bg }} aria-hidden="true" />
      {children}
    </motion.div>
  );
}
